import { render } from "./WorkCollectionItem.vue?vue&type=template&id=16e0ada2&scoped=true"
import script from "./WorkCollectionItem.vue?vue&type=script&lang=js"
export * from "./WorkCollectionItem.vue?vue&type=script&lang=js"

import "./WorkCollectionItem.vue?vue&type=style&index=0&id=16e0ada2&lang=less&scoped=true"

import exportComponent from "D:\\Web-Study\\01-study\\demo\\01-技术\\05-Vue\\Vue3\\01-学习过程&笔记\\项目\\01-作品集介绍页\\01-项目\\work_collection\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16e0ada2"]])

export default __exports__